<template id="modal-comment">
    <modal-container :config="config">
        <el-dialog :title="config.title ? config.title : title" :visible.sync="config.show"  width="30%">
            <span>{{ config.text ? config.text : text}}</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="close">{{cancel}}</el-button>
                <el-button type="primary" @click="$emit('closeModal')">{{confirm}}</el-button>
            </span>
        </el-dialog>
    </modal-container>
</template>

<script>
    import ModalContainer from './ModalContainer';
    import { closeModal } from './ModalHelpers'
    export default {
        props: {
            config: {
                type: Object,
                required: true
            },
            title: {
                type: String,
                default: "Delete"
            },
            text: {
                type: String,
                default: 'Are you sure you want to delete this record?'
            },
            cancel: {
                type: String,
                default: 'Cancel'
            },
            confirm: {
                type: String,
                default: 'Confirm'
            }
        },
        components: {
            'modal-container': ModalContainer,
        },
        methods: {
            close() {
                this.config.show = false;
                this.$emit('discarded')
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Modal/Modal.vue